import { useEffect, useState } from "react";
import { Button, Tooltip } from "antd";
import { FullscreenExitOutlined, FullscreenOutlined } from "@ant-design/icons";

/**
 * Fullscreen the app, as BMR_Frontend's FullscreenToggle.jsx does — useful
 * on a shop-floor screen where the browser chrome is just noise.
 */
export default function FullscreenToggle() {
  const [full, setFull] = useState(false);

  // The user can leave fullscreen with Esc without touching this button, so
  // the icon tracks the document rather than our own last click.
  useEffect(() => {
    const sync = () => setFull(Boolean(document.fullscreenElement));
    document.addEventListener("fullscreenchange", sync);
    return () => document.removeEventListener("fullscreenchange", sync);
  }, []);

  const toggle = () => {
    if (document.fullscreenElement) document.exitFullscreen?.();
    else document.documentElement.requestFullscreen?.();
  };

  return (
    <Tooltip title={full ? "Exit full screen" : "Full screen"} placement="bottom">
      <Button
        type="text"
        shape="circle"
        className="header-icon-btn"
        icon={full ? <FullscreenExitOutlined /> : <FullscreenOutlined />}
        onClick={toggle}
        aria-label={full ? "Exit full screen" : "Full screen"}
      />
    </Tooltip>
  );
}
